module.exports = __webpack_public_path__ + "static/image/main/card/image-2.ver2_0_2.png?4164d131";